import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/feature/Reveal';

const EXITS = [
  {
    id: 'stop',
    title: 'Hard stop, always',
    text: 'Every position opens with a hard stop sized to the trade, not to hope. A losing trade is never handed extra room to breathe.',
  },
  {
    id: 'target',
    title: 'Target decided up front',
    text: 'The take-profit sits at a measured multiple of the stop distance, so a trade\u2019s reward-to-risk is fixed before it is ever opened.',
  },
  {
    id: 'breakeven',
    title: 'Stop moves to break-even',
    text: 'Once a trade has covered its risk, the stop is pulled up to break-even — a position that has moved your way can no longer become a loser.',
  },
  {
    id: 'trail',
    title: 'Trailing stop',
    text: 'In trending sessions the stop trails behind price, letting a winner run while the locked-in floor keeps rising with it.',
  },
  {
    id: 'partial',
    title: 'Partial close',
    text: 'A first target banks part of the position; the remainder rides the trail, balancing a certain gain against a larger one.',
  },
  {
    id: 'timestop',
    title: 'Time stop',
    text: 'A trade that stalls without following through is closed rather than left to drift — if a setup has not worked within its window, it is treated as a miss, not a hope.',
  },
];

export default function ExitManagement() {
  return (
    <section
      id="exits"
      className="py-14 md:py-20 bg-background-100 border-y border-background-200 scroll-mt-32 md:scroll-mt-36"
    >
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Exits"
              title="Every trade knows how it ends before it opens"
              subtitle="Getting in cleanly is half the job. The other half is what happens after — and GoldWarden manages every open position by the same fixed rules, never by mood."
            />
          </Reveal>

          <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {EXITS.map((item, index) => (
              <Reveal key={item.id} delay={index * 60}>
                <div className="group h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-accent-300 transition-colors duration-200">
                  <div className="h-full border-l-2 border-accent-400 pl-4 md:pl-5 transition-colors duration-200 group-hover:border-accent-500">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}